import { render } from "./ObjectiveSectionResult.vue?vue&type=template&id=8dd9e98a&scoped=true"
import script from "./ObjectiveSectionResult.vue?vue&type=script&lang=js"
export * from "./ObjectiveSectionResult.vue?vue&type=script&lang=js"

import "./ObjectiveSectionResult.vue?vue&type=style&index=0&id=8dd9e98a&lang=scss&scoped=true"
import "./ObjectiveSectionResult.vue?vue&type=style&index=1&id=8dd9e98a&lang=scss"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8dd9e98a"]])

export default __exports__